module.exports = __webpack_public_path__ + "img/truck.be5030ca.webp";